import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { errorMessageKey } from '@nucleus-commerce/admin-kit/errors';
import { toast } from '@nucleus-commerce/ui/components/sonner';

import { usersApi } from '../api/users-api';
import { resendErrorKey } from '../schemas/user-rules';

import { userKeys } from './user-keys';

/**
 * Sends the set-password link again. Errors are toasted here rather than by the global policy so
 * 409 PASSWORD_ALREADY_SET reads as what it is instead of a generic conflict.
 */
export function useResendWelcome() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: (userId: string) => usersApi.resendWelcome(userId),
    meta: { successMessage: 'users:toasts.welcomeSent', silentError: true },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: userKeys.list() }),
    onError: (error) => {
      const { keys, requestId } = errorMessageKey(error);
      const specific = resendErrorKey(error);
      toast.error(specific ? t(specific) : t(keys.map((k) => `errors:${k}`)), {
        description: requestId ? t('errors:requestIdShort', { requestId }) : undefined,
      });
    },
  });
}
